'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconRatingStarAlt = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M19.805 10.12a1.507 1.507 0 0 0-1.213-1.027l-3.625-.523-1.626-3.27a1.5 1.5 0 0 0-2.685 0L9.035 8.569l-3.624.524a1.51 1.51 0 0 0-1.211 1.02 1.492 1.492 0 0 0 .382 1.542L7.2 14.191l-.619 3.585a1.5 1.5 0 0 0 2.174 1.582L12 17.662l3.248 1.7a1.5 1.5 0 0 0 2.174-1.584l-.622-3.586 2.618-2.537a1.5 1.5 0 0 0 .387-1.535z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M8.059 19.027a.995.995 0 0 1-.888-.538 1.001 1.001 0 0 1-.099-.632l.663-3.839-2.81-2.716a.999.999 0 0 1 .553-1.709l3.885-.562 1.74-3.507a.997.997 0 0 1 1.335-.461c.201.098.366.262.464.464l1.73 3.499 3.884.562a1.001 1.001 0 0 1 .553 1.708l-2.811 2.717.663 3.839a.997.997 0 0 1-.817 1.155.993.993 0 0 1-.631-.099L12 17.095l-3.479 1.818a1 1 0 0 1-.462.114zm2.083-9.317a.502.502 0 0 1-.376.273l-4.145.6 3 2.9a.5.5 0 0 1 .145.444l-.708 4.1 3.711-1.939a.49.49 0 0 1 .462-.001l3.705 1.934-.708-4.1a.5.5 0 0 1 .145-.444l3-2.9-4.144-.6a.5.5 0 0 1-.376-.273l-1.85-3.741-1.861 3.747z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M7.911 19.501a1.231 1.231 0 0 1-1.191-1.56l1.053-3.864-2.846-2.847a1.225 1.225 0 0 1-.361-.872A1.232 1.232 0 0 1 5.68 9.13l3.414-.342 1.804-3.607a1.23 1.23 0 0 1 1.658-.55c.237.119.433.316.551.553L14.91 8.79l3.415.342a1.235 1.235 0 0 1 .75 2.101l-2.844 2.844 1.054 3.863a1.232 1.232 0 0 1-.87 1.516 1.24 1.24 0 0 1-.872-.086l-3.541-1.771-3.54 1.772c-.174.086-.359.13-.551.13zm1.23-6.177c.19.19.264.469.193.728l-1.012 3.711 3.342-1.673a.749.749 0 0 1 .671-.001l3.344 1.672-1.013-3.71a.751.751 0 0 1 .193-.728l2.756-2.755-3.269-.327a.747.747 0 0 1-.596-.411L12 6.328l-1.751 3.501a.747.747 0 0 1-.596.411l-3.269.327 2.757 2.757z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconRatingStarAlt.displayName = 'IconRatingStarAlt';
exports.default = IconRatingStarAlt;